//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import PortalCredentialManagerTable from "@/pages/PortalCredentialManager/components/PortalCredentialManagerTable.vue";
import PortalCredentialManagerForm from "@/pages/PortalCredentialManager/components/PortalCredentialManagerForm.vue";
import { Feedback } from "@/utils/notify-toaster.js";

//Status corrente está a vir se o utilizador esta atualmente com sessão iniciada
const EMPTY_CREDENTIAL = {
  id: null,
  retailer: null,
  retailer_id: null,
  user_name: null,
  pasword: null,
};

export default {
  name: "PortalCredentialManager",
  components: {
    PortalCredentialManagerTable,
    PortalCredentialManagerForm,
  },
  mounted: function () {
    this.fetchCredentials();
  },
  data: () => ({
    data: null,
    recordsTotal: 0,
    isLoading: false,
    tableData: [],
    rightSideClicked: false,
    separator: "horizontal",
    pagination: {
      rowsPerPage: 30, // current rows per page being displayed
    },
    credential: {},
    drawerMode: "",
    isValidPassword: false,
  }),
  methods: {
    createNewCredential: function () {
      this.rightSideClicked = true;
      this.drawerMode = "create";
      this.data = EMPTY_CREDENTIAL;
    },
    renderRightSide: function (event) {
      this.drawerMode = "edit";
      this.rightSideClicked = true;
      this.data = event;
    },
    closeForm: function () {
      this.rightSideClicked = false;
      this.newPhantomClicked = false;
    },
    updateCredential(event) {
      this.credential = event;
    },
    async fetchCredentials() {
      this.isLoading = true;
      this.rightSideClicked = false;
      await BackendServices.getCredentialsList().then((response) => {
        this.recordsTotal = response.headers["x-total-count"];
        this.tableData = response.data;
        this.isLoading = false;
      });
    },

    save() {
      if (this.isValidPassword) {
        if (this.drawerMode === "create") {
          this.credential.created_by = this.$store.getters.userId;
          this.createCredential();
        } else if (this.drawerMode === "edit") {
          this.editCredential();
        }
      } else {
        Feedback.error("As passwords não coincidem");
      }
    },
    async createCredential() {
      await BackendServices.createCredential(this.credential);
      this.fetchCredentials();
      Feedback.success("Credencial criada com sucesso");
    },
    async editCredential() {
      await BackendServices.manageCredential(this.credential);
      this.fetchCredentials();
      Feedback.success("Credencial atualizada com sucesso");
    },
    async deleteCredential() {
      try {
        await BackendServices.deleteCredential(this.credential);
        this.fetchCredentials();
        Feedback.success("Credencial eliminada com sucesso");
      } catch (err) {
        let error = err;
        if (error.response.status == 403) {
          Feedback.error(error.response.data.error);
        } else {
          Feedback.error("Ocorreu um erro ao eliminar a credencial");
        }
      }
    },
    validPwd(checkPasswordValid) {
      this.isValidPassword = checkPasswordValid;
    },
  },
};
